import { extractApiErrors } from './apiErrors';

const DEFAULT_FORBIDDEN_MESSAGE = 'You do not have permission to perform this action.';

export const getForbiddenMessage = (error, fallback = DEFAULT_FORBIDDEN_MESSAGE) => {
  const { message, status } = extractApiErrors(error);
  if (status !== 403) return message;
  return message === 'An unexpected error occurred.' ? fallback : message;
};

export const getMutationError = (error, fallback = DEFAULT_FORBIDDEN_MESSAGE) => {
  const parsed = extractApiErrors(error);
  return {
    ...parsed,
    message: parsed.status === 403 ? getForbiddenMessage(error, fallback) : parsed.message,
  };
};

export const getUserMutationToast = (kind, overrides = {}) => {
  const base = {
    duration: 4000,
    isClosable: true,
  };

  if (kind === 'create') {
    return {
      ...base,
      title: 'User created',
      description: 'Access email sent.',
      status: 'success',
      ...overrides,
    };
  }

  if (kind === 'update') {
    return {
      ...base,
      title: 'User updated',
      description: 'Changes saved.',
      status: 'success',
      ...overrides,
    };
  }

  if (kind === 'roles') {
    return {
      ...base,
      title: 'Roles updated',
      description: 'Access changes saved.',
      status: 'success',
      ...overrides,
    };
  }

  if (kind === 'delete') {
    return {
      ...base,
      title: 'User deleted',
      description: 'The user has been removed.',
      status: 'success',
      ...overrides,
    };
  }

  return {
    ...base,
    status: 'info',
    ...overrides,
  };
};

export const getScopedUserBelongsToLabel = (context, lookup = {}) => {
  const contextType = context?.type || 'hke';
  const contextId = Number(context?.id);

  if (contextType === 'hke') return 'Platform';
  if (contextType === 'consultant') return lookup.consultantName || (contextId > 0 ? `Consultant #${contextId}` : 'Consultant');
  if (contextType === 'network') return lookup.networkName || (contextId > 0 ? `Network #${contextId}` : 'Network');
  if (contextType === 'organization') {
    return lookup.organizationName || (contextId > 0 ? `School #${contextId}` : 'School');
  }

  return 'Scope';
};
